import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PxToRemPipe } from './px-to-rem.pipe';

@NgModule({
  declarations: [PxToRemPipe],
  imports: [CommonModule],
  exports: [PxToRemPipe],
  providers: [PxToRemPipe]
})
export class PxToRemModule {}

export * from './px-to-rem.pipe';
